import { render, staticRenderFns } from "./locationSettingSidebar.vue?vue&type=template&id=53462993&scoped=true&"
import script from "./locationSettingSidebar.vue?vue&type=script&lang=js&"
export * from "./locationSettingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./locationSettingSidebar.vue?vue&type=style&index=0&id=53462993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53462993",
  null
  
)

export default component.exports